<template>
  <div id="app ">
    <div class="site-topbar">
      <div class="center">
        <ul class="pull-right">
          <li style="display: list-item" v-if="lang == 'chs'">
            <router-link to="../Sitemap" style="border-right: 1px solid #ccc"
              >站点地图</router-link
            >
          </li>
          <li style="display: list-item" v-else>
            <router-link to="../Sitemap" style="border-right: 1px solid #ccc"
              >Site Map</router-link
            >
          </li>
          <li style="display: list-item" class="language">
            <div
              :class="lang == 'chs' ? 'cur' : ''"
              class="j_syslang chs"
              style="display: inline-block"
              @click="toChs()"
            >
              简
            </div>
            <div
              :class="lang == 'eng' ? 'cur' : ''"
              class="j_syslang eng"
              style="display: inline-block"
              @click="toEng()"
            >
              EN
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div id="printBill">
      <header>
        <div class="center">
          <h1>
            <a href="https://www.waterwood.hk" id="j_siteLogo">
              <img src="../assets/images/new_logo.png" />
            </a>
          </h1>

          <nav id="j_nav" style="font-size: 16px">
            <ul class="sm" data-smartmenus-id="16231347097089768">
              <li
                v-for="(item, i) in navList"
                :key="i"
                @click="JumpTo(item)"
                :class="item.address === aName ? 'curTitle' : ''"
                class="nav_title"
              >
                <span v-if="lang == 'chs'">{{ item.name }}</span>
                <span v-else>{{ item.Ename }}</span>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <div class="container" style="clear: both">
        <router-view></router-view>
      </div>
    </div>
    <footer>
      <div class="center">
        <div class="footer_info_wrap">
          <div class="pull-left" v-if="lang == 'chs'">
            <div id="j_footerOrgName" class="site_name">
              水木投資管理有限公司
            </div>
            <div class="editor" data-w="c_0_chs" style="">
              <p>
                <router-link to="../disclaimer">免责声明</router-link
                >&nbsp;&nbsp;|&nbsp;
                <router-link to="../privacyPolicy">隐私声明</router-link>
              </p>
            </div>
          </div>
          <div class="pull-left" v-else>
            <div id="j_footerOrgName" class="site_name">
              Waterwood Investment Management Limited
            </div>
            <div class="editor" data-w="c_0_chs" style="">
              <p>
                <router-link to="../disclaimer">Disclaimer</router-link
                >&nbsp;&nbsp;&nbsp;|&nbsp;
                <router-link to="../privacyPolicy">Privacy Policy</router-link>
              </p>
            </div>
          </div>
          <div class="pull-right">
            <ul
              id="j_footerSNS"
              class="footerSNS social_wrap sina twitter facebook"
            ></ul>
          </div>
        </div>
        <div class="line"></div>
        <div class="site_explain">
          <p class="copyright">
            © <span id="j_copyrightYear">2025</span>
            <span id="j_copyrightOrgName" v-if="lang == 'chs'"
              >水木投資管理有限公司</span
            >
            <span id="j_copyrightOrgName" v-else
              >Waterwood Investment Management Limited</span
            >
            All Rights Reserved
          </p>
          <p id="j_poweredby_text" class="fae">Powered by EastSpider</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      lang: "",
      aName: "",
      navList: [
        {
          name: "首页",
          Ename: "Home Page",
          address: "homePage",
          Roter: "HomePage",
        },
        { name: "关于", Ename: "About", address: "about", Roter: "About" },
        {
          name: "投资企业",
          Ename: "Portfolio Companies",
          address: "portfolioCompanies",
          Roter: "PortfolioCompanies",
        },
        {
          name: "投资者登入",
          Ename: "Investor Login",
          address: "investorLogin",
          Roter: "InvestorLogin",
        },
        // { name: "员工登入", Ename: "Staff Login", address: "staffLogin",Roter:'StaffLogin' },
        {
          name: "工作机会",
          Ename: "Career",
          address: "career",
          Roter: "Career",
        },
        {
          name: "联系我们",
          Ename: "Contact Us",
          address: "contactUs",
          Roter: "ContactUs",
        },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.aName = window.location.hash.split("/")[1];
    if (this.aName == "") {
      this.aName = "homePage";
    }
    let lang = sessionStorage.getItem("lang");
    if (lang) {
      this.lang = lang;
    } else {
      this.lang = "chs";
    }
  },
  created() {},
  methods: {
    toChs() {
      this.lang = "chs";
      this.$store.commit("setLang", "chs");
      sessionStorage.setItem("lang", "chs");
    },
    toEng() {
      this.lang = "eng";
      this.$store.commit("setLang", "eng");
      sessionStorage.setItem("lang", "eng");
    },
    JumpTo(item) {
      let add = item.Roter;
      if (item.address !== "investorLogin") {
        if (item.address) {
          this.aName = item.address;
        } else {
          this.aName = "homePage";
        }
      }
      if (item.address == "investorLogin") {
        // window.location.href = "http://47.105.170.76:8081/login";
        if (this.lang == "eng") {
          window.open("http://8.217.65.217:8081/login#lang=en");
        } else {
          window.open("http://8.217.65.217:8081/login#lang=cn");
        }
      } else if (item.address == "staffLogin") {
        // window.location.href =
        //   "https://account.eastspider.com/login/info?param=MW29MUZhWBKQZEYlx9e7R1iRPVMQLVglKMvlGs5ztiFuGze-bAqkeJVxaQyNMK-gWvreiPka5VmK8FICzY-nDGI-14IF7P8p1k446-sR_lT851odWeTrYNA2Zeuvm0y4sJlvJzIc62LrkHFgacWQ-uu7ls7Tq-j2ABvkfk7oevDHPEkzQSqdMtlTeJY9vaIkVVC485SMpPigUYGUePlS3sv2fQ8wbFyrAw8Z3zftD4A6xVPhBkWhJwhU4Q2Mz2lLDDPIzKPRoWzCm9vr0DtlaC4VelWLv2gGHOgIDNvlSuhOrKuoobKOfaMpVSpB8wvOqlSeeJ7dM6Zc8bYkPzXqL3cLrsEh9k27wdy4yRarzOho-Co6UK7UWs5wlT7A-J3DavNlW1efZi0VOndVhd7UOK-INw_P3EeLlS5ZUyfTxiqakNW5WK34dw2PtyS5a9Dj7PS0C8cz71TkNakAN-vBdXXmylgRZ9PwiZtFs4PE4sMTFZZwZ72BDW9U2GBG5gwh";
        window.open(
          "https://account.eastspider.com/login/info?param=MW29MUZhWBKQZEYlx9e7R1iRPVMQLVglKMvlGs5ztiFuGze-bAqkeJVxaQyNMK-gWvreiPka5VmK8FICzY-nDGI-14IF7P8p1k446-sR_lT851odWeTrYNA2Zeuvm0y4sJlvJzIc62LrkHFgacWQ-uu7ls7Tq-j2ABvkfk7oevDHPEkzQSqdMtlTeJY9vaIkVVC485SMpPigUYGUePlS3sv2fQ8wbFyrAw8Z3zftD4A6xVPhBkWhJwhU4Q2Mz2lLDDPIzKPRoWzCm9vr0DtlaC4VelWLv2gGHOgIDNvlSuhOrKuoobKOfaMpVSpB8wvOqlSeeJ7dM6Zc8bYkPzXqL3cLrsEh9k27wdy4yRarzOho-Co6UK7UWs5wlT7A-J3DavNlW1efZi0VOndVhd7UOK-INw_P3EeLlS5ZUyfTxiqakNW5WK34dw2PtyS5a9Dj7PS0C8cz71TkNakAN-vBdXXmylgRZ9PwiZtFs4PE4sMTFZZwZ72BDW9U2GBG5gwh"
        );
      } else {
        this.$router.push({ name: add });
      }
    },
    handleScroll() {
      this.scroll =
        document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
      //   if (this.scroll > 600) {
      //     //判断滚动后高度超过400px,就显示
      //     this.$refs.btn.style.display = "block";
      //   } else {
      //     this.$refs.btn.style.display = "none";
      //   }
    },
  },
};
</script>

<style scoped>
.center {
  width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
}

.site-topbar {
  height: 31px;
  line-height: 31px;
  color: #666;
  background: #f5f5f5;
  border-bottom: 1px solid #e5e5e5;
}

.pull-right {
  float: right;
}

.pull-right li {
  float: left;
}
.language {
  margin-left: 5px;
}
.pull-right li a {
  width: 18px;
  height: 18px;
  line-height: 18px;
  color: #666;
  font-size: 14px;
  margin: 8px 0;
}
.pull-right li:nth-child(1) a {
  padding: 0 8px 0 0;
}

.pull-right li a img {
  display: inline-block;
  width: 18px;
  height: 18px;
  padding: 8px 5px;
}

.pull-right li .j_syslang {
  margin: 0 4px 0 0;
  width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
}

.pull-right li .cur {
  color: #333;
}

header {
  height: 155px;
  width: 100%;
  line-height: 60px;
  background: #fff;
}

header .center {
  padding: 30px 15px;
  position: relative;
}

header .center h1 {
  width: 266px;
  height: 95px;
}

header .center h1 a img {
  width: 266px;
  height: 95px;
}

nav {
  position: absolute;
  bottom: 30px;
  right: 0;
  height: 41px;
}

nav .sm {
}

nav .sm li {
  float: left;
  height: 39px;
}
.nav_title {
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
}
.curTitle {
  color: #11b0ff;
}
.nav_title_cur {
  padding-left: 20px;
  padding-right: 20px;
  cursor: pointer;
  color: #11b0ff;
}
.container {
  min-height: 540px;
}
footer {
  height: 192px;
  background: rgb(47, 77, 159);
  margin-top: 50px;
}
footer a {
  color: #fff;
}
footer .center {
  padding: 40px 0 20px 0;
}

footer .center .footer_info_wrap {
  height: 58px;
}

footer .center .footer_info_wrap .pull-left .site_name {
  color: #fff;
  font-size: 18px;
  margin-bottom: 15px;
}

footer .center .footer_info_wrap .pull-left .editor {
  color: #fff;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

footer .center .line {
  margin: 20px 0 15px 0;
  width: 1200px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

footer .center .site_explain .copyright {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
}

footer .center .site_explain #j_poweredby_text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  text-align: center;
}
</style>
